export default {
  showForeignReviews: state => state.newOtherConfig.show_country_and_foreign_reviews,
};
